import classNames from "classnames";
import useIframe from "utils/iframe/useIframe";
import externals from "utils/externals";
import styles from "../../ServiceIframe.module.scss";
import { useSelector } from "react-redux";
import useCurrentService from "utils/useCurrentService";
import { appComponents as i18nNamespace } from "../../../../i18n/namespace";
import { useTranslation } from "react-i18next";

/**
 * V1 is deprecated, dont update it, any new integrations must be on V2
 */
export const RenderV1 = ({ version, iframeKey, isThirdParty, trackKey, setWizardOpen, isWizardOpen }) => {
    const { t } = useTranslation(i18nNamespace);
    const isNewNav = useSelector((state) => state.features.active['NetApp.NewNav/*'] ?? false);
    const service = useCurrentService();
    const { iframeRef, src } = useIframe({ iframeUrl: externals.serviceIframes[iframeKey], isThirdParty, trackKey, setWizardOpen })

    return <iframe title={t("service")} allow="clipboard-write; clipboard-read" src={src} ref={iframeRef} className={classNames((isNewNav ? (service.isShowingSelectedServiceNav ? styles.appBase : styles.appBaseWithoutLeftNav) : styles.base), { [styles['sub-tab']]: !service.isShowingSelectedServiceNav && version === "childIframe/v1" && !isWizardOpen })}/>
};